// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  initializeAuth,
  getReactNativePersistence,
} from 'firebase/auth/react-native';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBxI-giZacQr5lbCwUI4H41pyxR8R1MCIY',
  authDomain: 'auditaware-qa.firebaseapp.com',
  projectId: 'auditaware-qa',
  storageBucket: 'auditaware-qa.appspot.com',
  messagingSenderId: '659740156875',
  appId: '1:659740156875:web:bc837c5299159c2649cc4e',
  measurementId: 'G-93KBXYH515',
};

// Initialize Firebase/Firestore
const app = initializeApp(firebaseConfig);
const auth = initializeAuth(app, {
  persistence: getReactNativePersistence(AsyncStorage),
});

export const storage = getStorage(app);
export const db = getFirestore();
export { auth };
